// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  if (typeof state === "number") {
    if (state !== 0) {
      if (typeof action === "number") {
        if (action !== 0) {
          return /* Init */0;
        } else {
          return state;
        }
      } else {
        return /* Error */{
                _0: action._0
              };
      }
    } else if (action === 0) {
      return /* Submitting */1;
    } else {
      return state;
    }
  } else {
    return state;
  }
}

export {
  reducer ,
  
}
/* No side effect */
